$(document).ready(
    function () {

        let p = $("body").attr("p");
        let a = $("body").attr("a");

        function addMaxTicketPerOrder() {
            let maxTicketsPerOrder = $('#max_tickets_per_order').attr('max') * 1;
            if ($('#max_tickets_per_order').val() == '' && typeof ($('#max_tickets').val() * 1) == 'number' && ($('#max_tickets').val() * 1) > 0) {
                if ($('#max_tickets').val() >= maxTicketsPerOrder) {
                    $('#max_tickets_per_order').val(maxTicketsPerOrder);
                } else {
                    $('#max_tickets_per_order').val($('#max_tickets').val());
                }
            }
        }

        if (p == 'organizer_event' && a == 'new') {
            $(document).on("focusout ", '#max_tickets', function () {
                addMaxTicketPerOrder();
            });
        }

        if (p == 'organizer_event' && (a == 'new' || a == 'update')) {

            $(document).on("change", '#no_end_date', function () {
                if ($('#no_end_date').prop("checked") === true) {
                    hideEndDateInput();
                } else {
                    showEndDateInput();
                }
            });

            $(document).on("change", '#timeslot-minutes-checkbox', function () {
                if ($('#timeslot-minutes-checkbox').prop("checked") === true) {
                    $('#timeslot-minutes-input-container').removeClass('d-none');
                    $('#timeslot-average-duration-input-container').removeClass('d-none');
                    $('#max-tickets-label').addClass('d-none');
                    $('#max-tickets-timeslot-label').removeClass('d-none');
                } else {
                    if (!$('#timeslot-minutes-input-container').hasClass('d-none')) {
                        $('#timeslot-minutes-input-container').addClass('d-none');
                    }
                    if (!$('#timeslot-average-duration-input-container').hasClass('d-none')) {
                        $('#timeslot-average-duration-input-container').addClass('d-none');
                    }

                    $('#max-tickets-label').removeClass('d-none');
                    if (!$('#max-tickets-timeslot-label').hasClass('d-none')) {
                        $('#max-tickets-timeslot-label').addClass('d-none');
                    }
                }
            });

            function hideEndDateInput() {
                $('#end').removeAttr('required');
                $('#end').val('');
                $('#end').addClass('d-none');
            }

            function showEndDateInput() {
                $('#end').removeClass('d-none');
            }

            $(document).on("change", '#recurring', function () {
                let maxGroupTicketsPerOrderWrapper = $('#max-group-tickets-per-order-wrapper');
                if ($(this).prop("checked") === true) {
                    let eventDateAndTimeLabelText = $('#event-data-and-time-label').attr('data-event-subevent-data-and-time-label-text');
                    $('#event-data-and-time-label').text(eventDateAndTimeLabelText);
                    if ($('#start_date').val().length == 0) {
                        $('#start_date').val($('#start_date').attr('data-todays-date'));
                    }
                    getSubEventRegistrationForm();
                    if ($('#area').prop("checked") == true && $('.event-area-zone-date-wrapper').hasClass('d-none')) {
                        $('.event-area-zone-date-wrapper').removeClass('d-none');
                    }
                    if(maxGroupTicketsPerOrderWrapper.length > 0 && maxGroupTicketsPerOrderWrapper.hasClass('d-none')){
                        maxGroupTicketsPerOrderWrapper.removeClass('d-none');
                    }
                } else {
                    $('form#event_register_form').removeClass('has-changed');
                    window.location.reload();
                }
            });

            $(document).on("change", '#area', function () {
                if ($(this).prop("checked") === true) {
                    getAreaZoneRegistrationForm();
                    $('#max_tickets').attr("disabled", true);
                    $('#max_tickets').val(null);
                } else {
                    $('#area_zone').remove();
                    $('#max_tickets').removeAttr('disabled');
                }
            });

            $(document.body).on('change', "#activity", function () {
                if ($(this).val() == 'custom') {
                    $('#custom_activity').removeClass('d-none');
                } else {
                    $('#custom_activity').addClass('d-none');
                }
            });

            if ($('#recurring').prop("checked") === true) {
                getSubEventRegistrationForm();
            }

            if ($('#area').prop("checked") === true) {
                $('#max_tickets').attr("disabled", true);
                getAreaZoneRegistrationForm();
            }

            $(document).on('click', '#subevent_generation_toggle', function () {
                let subeventDiv = $('#subevent');
                if (subeventDiv.hasClass('d-none')) {
                    subeventDiv.removeClass('d-none');
                    $(this).remove();

                    let startDateSubeventElement = $('.datepicker-start-date-subevent');
                    let startDateEditable = (startDateSubeventElement.data('existing') && startDateSubeventElement.data('existing') !== undefined && startDateSubeventElement.data('existing') == 0);

                    let $startDateSubeventGeneration = $(".datepicker-start-date-subevent").pickadate({
                        format: 'yyyy-mm-dd',
                        formatSubmit: 'yyyy-mm-dd',
                        editable: startDateEditable
                    });

                    let $endDateSubeventGeneration = $(".datepicker-end-date-subevent").pickadate({
                        format: 'yyyy-mm-dd',
                        formatSubmit: 'yyyy-mm-dd',
                        editable: true
                    });

                    let pickerStartDateSubeventGeneration = $startDateSubeventGeneration.pickadate('picker');
                    let pickerEndDateSubeventGeneration = $endDateSubeventGeneration.pickadate('picker');

                    $(document).on("click", ".datepicker-start-date-subevent", function () {
                        if (startDateEditable) {
                            pickerStartDateSubeventGeneration.set('max', pickerEndDateSubeventGeneration.get());
                            pickerStartDateSubeventGeneration.open();
                        }
                    });

                    $(document).on("click", ".datepicker-end-date-subevent", function () {
                        pickerEndDateSubeventGeneration.set('min', pickerStartDateSubeventGeneration.get());
                        pickerEndDateSubeventGeneration.open();
                    });
                } else {
                    subeventDiv.addClass('d-none');
                }
            });

            $(document).on('click', '#event_register_form .event_subevent_period_info_btn', function () {
                let li = $(this).closest('li');
                let info = $('.event_subevent_period_info', li);
                if (info.hasClass('d-none')) {
                    info.removeClass('d-none');
                    $('.event_subevent_period_info_btn_icon_closed', li).addClass('d-none');
                    $('.event_subevent_period_info_btn_icon_open', li).removeClass('d-none');
                } else {
                    info.addClass('d-none');
                    $('.event_subevent_period_info_btn_icon_open', li).addClass('d-none');
                    $('.event_subevent_period_info_btn_icon_closed', li).removeClass('d-none');
                }
            });

            function getSubEventRegistrationForm() {
                let eventId = null;
                if (typeof $('#event_id') !== 'undefined' && typeof $('#event_id') != false && typeof ($('#event_id').val() * 1) == 'number' && ($('#event_id').val() * 1) > 0) {
                    eventId = $('#event_id').val() * 1;
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_event/get_subevent",
                    data: {
                        event_id: eventId
                    }
                })
                    .done(function (data) {
                        if (data.html !== undefined && data.html !== null) {
                            $('#subevent-generation-wrapper').html('').removeClass('d-none').html(data.html);
                            $('#event-start-and-end-date').remove();
                        }
                    })
                    .fail(function (data) {
                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }
                    });
            }


            function getAreaZoneRegistrationForm() {
                let eventId = null;
                if (typeof $('#event_id') !== 'undefined' && typeof $('#event_id') != false && typeof ($('#event_id').val() * 1) == 'number' && ($('#event_id').val() * 1) > 0) {
                    eventId = $('#event_id').val() * 1;
                }

                $.ajax({
                    type: 'POST',
                    url: "/ajax/organizer_event/get_area_zone",
                    data: {
                        event_id: eventId
                    }
                })
                    .done(function (data) {
                        if (data.html !== undefined && data.html !== null) {
                            $('#area_zone').remove();
                            $('#discount').after(data.html);
                            if ($('#recurring').prop("checked") != true && !$('.event-area-zone-date-wrapper').hasClass('d-none')) {
                                $('.event-area-zone-date-wrapper').addClass('d-none');
                            }
                            addDatePicker();
                        }

                    })
                    .fail(function (data) {

                        if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                            document.location.href = data.responseJSON.redirect_url;
                        }

                    });

            }

            function addDatePicker() {
                let date = new Date();
                $('.datepicker-event-area-zone-valid-to-date').each(function () {
                    let $endDate = $(this).closest('.form-row').find(".datepicker-event-area-zone-valid-to-date").pickadate({
                        format: 'yyyy-mm-dd',
                        formatSubmit: 'yyyy-mm-dd',
                        min: [date.getFullYear(), date.getMonth(), date.getDate()],
                        editable: true
                    });
                    $endDate.on('click', function (ev) {
                        ev.stopPropagation();
                        ev.preventDefault();
                        let pickerEndDateStatistic = $endDate.data('pickadate');
                        pickerEndDateStatistic.set('min', date);
                        pickerEndDateStatistic.open();
                    });
                });
            }

        }

        $(document.body).on('click', ".event-area-zone", function () {
            if ($('#area').prop("checked") == true) {
                let max_tickets = 0;
                $('.event-area-zone').each(function () {
                    if ($(this).prop("checked") == true) {
                        max_tickets += $(this).attr('data-people-limit') * 1;
                    }
                });
                $('#max_tickets').val(max_tickets);
                addMaxTicketPerOrder();
            }
        });


    });